import { useState, useEffect, type ReactElement } from 'react';
import Search from './../components/Search';
import FeaturedRecipeCard from './../components/FeaturedRecipeCard';
import InspirationSection from './../components/InspirationSection';
import { useAuth } from '../lib/auth-context';
import recipeService from '../lib/recipe-service';
import { type Recipe } from '../types';

/**
 * The front page is a working surface, not a pitch: find a recipe, see what
 * the pantry can cook tonight, see what changed.
 */
function Home(): ReactElement {
	const { isLoggedin } = useAuth();
	// Last visit's listing paints at once; the fetch below refreshes it
	const cached = recipeService.peekRecipes(1, 5);
	const [numRecipes, setNumRecipes] = useState<number>(cached?.meta.total ?? 0);
	const [recipes, setRecipes] = useState<Recipe[]>(cached?.recipes ?? []);

	useEffect(() => {
		recipeService
			.getRecipes(1, 5)
			.then(({ recipes, meta }) => {
				setNumRecipes(meta.total);
				setRecipes(recipes);
			})
			.catch((error) => console.error(error));
	}, []);

	return (
		<div className='container page'>
			<div className='page-head'>
				<div>
					<h1 className='display'>What can you make tonight?</h1>
					<p className='page-head__sub body'>
						Search <span className='figure' style={{ color: 'var(--ink)' }}>{numRecipes}</span> recipes by
						name or ingredient, or cook from what is already in your pantry.
					</p>
				</div>
			</div>
			<div style={{ marginBottom: 'var(--space-5)', maxWidth: 640 }}>
				<Search />
			</div>
			<div className={isLoggedin ? 'two' : undefined}>
				{isLoggedin && (
					<div>
						<InspirationSection />
					</div>
				)}
				<section className='panel' aria-labelledby='recent-heading'>
					<div className='pad-head'>
						<h2 id='recent-heading' className='heading'>Recently updated</h2>
					</div>
					<ul className='res-list'>
						{recipes.map((recipe) => (
							<li key={recipe._id}><FeaturedRecipeCard recipe={recipe} /></li>
						))}
					</ul>
				</section>
			</div>
		</div>
	);
}

export default Home;
